import { ApiClientError } from '@/api/errors';
import { useI18n } from '@/i18n/I18nProvider';
import { ErrorState } from './States';

/** Download failures: a missing PDF is a calm note, anything else is the standard error box. */
export function ErrorMessage({ error }: { error: unknown }) {
  const { t } = useI18n();
  if (error instanceof ApiClientError && error.code === 'pdf_not_available') {
    return (
      <p role="status" className="text-callout text-typography-secondary">
        {t('invoice.pdfPending')}
      </p>
    );
  }
  return <ErrorState error={error} className="print:hidden" />;
}
